import React from "react";
import SignaturePad from "../components/SignaturePad";
function SummaryRow({ label, value, ltr = false }) {
  if (!value) return null;
  return (
    <div className="flex justify-between gap-4 border-b border-gray-100 py-2 text-sm last:border-b-0">
      <span className="text-gray-500">{label}</span>
      <span
        className="font-medium text-navy"
        style={ltr ? { direction: "ltr", unicodeBidi: "embed" } : {}}
      >
        {value}
      </span>
    </div>
  );
}
const CONDITION_LABELS = {
  healthy: "سالم و بدون نقص",
  minor_issue: "دارای ایراد جزئی",
  needs_repair: "نیازمند تعمیر",
};

const PARTY_LABELS = {
  seller: "فروشنده",
  buyer: "خریدار",
};

export default function Step7Signature({ data, onSignatureChange, flowType }) {
  const isSinglePersonMode = flowType === "single-person";

  return (
    <div>
      <h2 className="text-lg font-bold text-navy">بازبینی و امضای نهایی</h2>
      <p className="mt-1 text-sm text-gray-500">
        {isSinglePersonMode
          ? "در این حالت می‌توانید اطلاعات را تکمیل کنید و در صورت تمایل امضاء را وارد نکنید."
          : "پیش از ثبت نهایی، اطلاعات وارد شده را بررسی و سپس امضای خود را ثبت کنید."}
      </p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">
            اطلاعات فروشنده
          </h3>
          <SummaryRow
            label="نام و نام خانوادگی"
            value={`${data.firstName || ""} ${data.lastName || ""}`.trim()}
          />
          <SummaryRow label="کد ملی" value={data.nationalCode} />
          <SummaryRow label="تلفن همراه" value={data.mobile} />
        </div>

        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">
            اطلاعات خودرو
          </h3>
          <SummaryRow
            label="نام و مدل"
            value={`${data.vehicleName || ""} ${data.vehicleModel || ""}`.trim()}
          />
          <SummaryRow label="رنگ" value={data.vehicleColor} />
          <SummaryRow label="پلاک" value={data.plateNumber} />
        </div>

        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">مبلغ معامله</h3>
          <SummaryRow
            label="مبلغ به تومان"
            value={
              data.amountToman &&
              `${Number(data.amountToman).toLocaleString("fa-IR")} تومان`
            }
          />
          <SummaryRow
            label="مبلغ به ریال"
            value={
              data.amountRial &&
              `${Number(data.amountRial).toLocaleString("fa-IR")} ریال`
            }
          />
        </div>

        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">
            تحویل و دفترخانه
          </h3>
          <SummaryRow
            label="هزینه نقل و انتقال"
            value={PARTY_LABELS[data.transferFeeBy]}
          />
          <SummaryRow
            label="هزینه شماره‌گذاری"
            value={PARTY_LABELS[data.plateFeeBy]}
          />
          <SummaryRow
            label="وضعیت خودرو"
            value={CONDITION_LABELS[data.vehicleCondition]}
          />
          <SummaryRow
            label="کیلومتر"
            value={
              data.vehicleMileage &&
              `${Number(data.vehicleMileage).toLocaleString("fa-IR")} کیلومتر`
            }
          />
        </div>
      </div>

      <div className="mt-6">
        <label className="mb-1.5 block text-sm font-medium text-navy-light">
          {isSinglePersonMode ? "امضای ثبت‌کننده (اختیاری)" : "امضای فروشنده"}
          {!isSinglePersonMode && <span className="text-red-500">*</span>}
        </label>
        {isSinglePersonMode && (
          <p className="mb-2 text-xs text-gray-500">
            امضا اختیاری است؛ اگر بخواهید می‌توانید این بخش را خالی بگذارید.
          </p>
        )}
        <SignaturePad value={data.signature} onChange={onSignatureChange} />
      </div>
    </div>
  );
}
